import ApiRequest from "../utils/ApiRequest";
// import GlobalData from "../util/GlobalData";

export default class Material {
    getListMaterial = async (q) => {
        return await ApiRequest.set(`/v1/material/list-material?q=${q}`, "GET");
    }
}